import { EntityAction, EntityActionList, ExtensionsService } from '@abp/ng.components/extensible';
import { DEFAULT_TENANTS_ENTITY_ACTIONS, eSaasComponents, SaasEntityActionContributors } from '@volo/abp.ng.saas';
import {SaasTenantDto} from '@volo/abp.ng.saas/proxy';
import { inject } from '@angular/core';
import { ConfigStateService } from '@abp/ng.core';


const alertTenantName = new EntityAction<SaasTenantDto>({
  text: 'Click Me!',
  action: (data) => {
    // Replace alert with your custom code
    alert(data.record.name);
  },
  // See EntityActionOptions in API section for all options
});

export function alertTenantNameContributor(actionList: EntityActionList<SaasTenantDto>) {
  const config = inject(ConfigStateService)

  actionList.dropByValue(DEFAULT_TENANTS_ENTITY_ACTIONS[2]); // ApplyDatabaseMigrations
  actionList.dropByValue(DEFAULT_TENANTS_ENTITY_ACTIONS[1]); // ConnectionStrings

  const currentUser = config.getOne("currentUser");

  if(currentUser) {
    const isInHostTenant = currentUser.tenantId == null;

    if(isInHostTenant)
    {
      if(!currentUser.roles?.includes('admin')) {
        actionList.dropByValue(DEFAULT_TENANTS_ENTITY_ACTIONS[6]);
      } 
    } else {
      actionList.dropByValue(DEFAULT_TENANTS_ENTITY_ACTIONS[6]);
    }
  }
}
  

export const tenantManagementEntityActionContributors: SaasEntityActionContributors = {
  // enum indicates the page to add contributors to
  [eSaasComponents.Tenants]: [
    alertTenantNameContributor,
    // You can add more contributors here
  ],
};
